import { mediaService } from '../configs/constants';
import {message} from 'antd';
import axios from './axiosInceptor';
const presignedImageUrl = `${mediaService}/document/getDocument`; //maintenance/getDocuments  OLD API URL
export const getPresignedImage = async (documentIdArray, preview = true, medialObj = false) => {
    const heads = {
      "organization-unit": "AGP",
      "bussiness-unit": "AUTO",
      channel: "MOBILE",
      "accept-language": "EN",
      source: "Orion",
      accept: "application/json",
      "Content-Type": "multipart/form-data",
      // 'Access-Control-Allow-Origin': 'no-cors', // Add the no-cors header
    };
    const mediaUrls = [];
    for (let documentId of documentIdArray) {
      await axios
        .get(`${presignedImageUrl}/${documentId}?preview=${preview}`, {
          headers: heads,
        })
        .then((x) => {
          if (medialObj) {
            mediaUrls.push(x.data?.result);
          } else {
            mediaUrls.push(x.data?.result?.location);
          }
        })
        .catch((e) => {
          const { response } = e;
          response?.data?.error && message.error(response?.data?.error);
        });
    }
    return mediaUrls;
  };


//   for upload document 

export const uploadDocumentMedia = async (payload,isSigned=true) => {
  
    console.log(payload,isSigned,"uploadDocumentMedia");
    
    if(isSigned === false) payload["isSigned"] = isSigned;
    const url = `${mediaService}/document/uploadFile`;
    return await axios.post(url, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };